import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class HostnameInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    const hostname = environment.apiUrl;
    const requestUrl = request.url;

    if (requestUrl.includes('token')) {
      return next.handle(request);
    }

    const clonedRequest = request.clone({
      url: `${hostname}${request.url}`
    });

    return next.handle(clonedRequest);
  }
}